import * as React from "react";
const SvgCheck = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M24 43.1201L12.88 32.0001L9.09332 35.7601L24 50.6667L56 18.6667L52.24 14.9067L24 43.1201Z", fill: "black" }));
export default SvgCheck;
